import i18next from "i18next";

export interface ISearchModeField {
  key: string;
  label: string;
}

export interface ISearchModeConfig {
  key: string;
  simpleFields: ISearchModeField[];
  advancedFields: ISearchModeField[];
}

const buildClientSearchConfig = (t: any): ISearchModeConfig => ({
  key: "clients",
  simpleFields: [
    { key: "companyName", label: t("clients.searchFilters.companyName", { ns: "admin" }) as string },
    { key: "shortName", label: t("clients.searchFilters.shortName", { ns: "admin" }) as string },
    { key: "city", label: t("clients.searchFilters.city", { ns: "admin" }) as string },
    { key: "street", label: t("clients.searchFilters.street", { ns: "admin" }) as string },
    { key: "postalCode", label: t("clients.searchFilters.postalCode", { ns: "admin" }) as string },
    { key: "taxNumber", label: t("clients.searchFilters.taxNumber", { ns: "admin" }) as string },
    { key: "bdoNumber", label: t("clients.searchFilters.bdoNumber", { ns: "admin" }) as string },
  ],
  advancedFields: [
    { key: "vatStatus", label: t("clients.searchFilters.vatStatus", { ns: "admin" }) as string },
    { key: "verified", label: t("clients.searchFilters.verified", { ns: "admin" }) as string },
    { key: "multiDepartment", label: t("clients.searchFilters.multiDepartment", { ns: "admin" }) as string },
    { key: "deactivationReason", label: t("clients.searchFilters.deactivationReason", { ns: "admin" }) as string },
    { key: "orderTypes", label: t("clients.searchFilters.orderTypes", { ns: "admin" }) as string },
    { key: "source", label: t("clients.searchFilters.source", { ns: "admin" }) as string },
  ],
});

const buildOrderSearchConfig = (t: any): ISearchModeConfig => ({
  key: "orders",
  simpleFields: [
    { key: "number", label: t("orders.searchFilters.number", { ns: "admin" }) as string },
    { key: "company", label: t("orders.searchFilters.company", { ns: "admin" }) as string },
    { key: "city", label: t("orders.searchFilters.city", { ns: "admin" }) as string },
    { key: "street", label: t("orders.searchFilters.street", { ns: "admin" }) as string },
    { key: "postalCode", label: t("orders.searchFilters.postalCode", { ns: "admin" }) as string },
    { key: "cuoOrderNumber", label: t("orders.searchFilters.cuoOrderNumber", { ns: "admin" }) as string },
  ],
  advancedFields: [
    { key: "createdAt", label: t("orders.searchFilters.createdAt", { ns: "admin" }) as string },
    { key: "acceptedDate", label: t("orders.searchFilters.acceptedDate", { ns: "admin" }) as string },
    { key: "type", label: t("orders.searchFilters.type", { ns: "admin" }) as string },
    { key: "quantity", label: t("orders.searchFilters.quantity", { ns: "admin" }) as string },
    { key: "contactPhone", label: t("orders.searchFilters.contactPhone", { ns: "admin" }) as string },
    { key: "vehicleBrand", label: t("orders.searchFilters.vehicleBrand", { ns: "admin" }) as string },
    { key: "vehicleModel", label: t("orders.searchFilters.vehicleModel", { ns: "admin" }) as string },
    { key: "vehicleRegistration", label: t("orders.searchFilters.vehicleRegistration", { ns: "admin" }) as string },
    { key: "orderTypeItemName", label: t("orders.searchFilters.orderTypeItemName", { ns: "admin" }) as string },
    { key: "orderTypeItemValue", label: t("orders.searchFilters.orderTypeItemValue", { ns: "admin" }) as string },
    { key: "operator", label: t("orders.searchFilters.operator", { ns: "admin" }) as string },
    { key: "invoiceNumber", label: t("orders.searchFilters.invoiceNumber", { ns: "admin" }) as string },
    { key: "optimaNumber", label: t("orders.searchFilters.optimaNumber", { ns: "admin" }) as string },
    { key: "internalStoreName", label: t("orders.searchFilters.internalStoreName", { ns: "admin" }) as string },
    { key: "internalStoreDistance", label: t("orders.searchFilters.internalStoreDistance", { ns: "admin" }) as string },
    { key: "source", label: t("orders.searchFilters.source", { ns: "admin" }) as string },
  ],
});

export const getClientsSearchModeConfig = (): ISearchModeConfig => buildClientSearchConfig(i18next.t);
export const getOrdersSearchModeConfig = (): ISearchModeConfig => buildOrderSearchConfig(i18next.t);